import { render, staticRenderFns } from "./OrderWaitDialog.vue?vue&type=template&id=447996c6&"
import script from "./OrderWaitDialog.vue?vue&type=script&lang=js&"
export * from "./OrderWaitDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderWaitDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports